import React from "react";
import { useTranslation } from "react-i18next";

/** "Join U14 Girls · Ballyboden": the team an invite link is for. */
export default function JoinTeamHeader({ invite }) {
  const { t } = useTranslation();
  return (
    <div className="mb-6 text-center">
      <p className="text-sm font-medium text-[#6B7280]">
        {invite.workspace_name}
      </p>
      <h1 className="mt-1 text-2xl font-bold text-[#111827]">
        {t("auth.joinTeam.title", { team: invite.team_name })}
      </h1>
    </div>
  );
}
